import React from "react";
import {useState, useEffect} from 'react';
import {Link, NavLink, useLocation, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';

import {useEmployeeLoginMutation} from "../../features/userApiSlice";
import {setCredentials} from "../../features/authSlice";
import {useDispatch, useSelector} from "react-redux";
import {assets} from "../../assets/assets";
import LoadingButton from "../../../src/screens/AttendenceScreen/LoadingButton";


export default function EmployeeLoginScreen() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [login, {isLoading}] = useEmployeeLoginMutation();

    // @ts-ignore
    const {userInfo} = useSelector((state) => state.auth)
    const {search} = useLocation();
    const sp = new URLSearchParams(search);
    const redirect = sp.get("redirect") || "/dashboard";

    const [lastName, setlastName] = useState<string>('')
    const [employeeNumber, setemployeeNumber] = useState<string>('')

    const onSubmitHandler = async (e: any) => {
        e.preventDefault();
        try {
            const res = await login({lastName, employeeNumber}).unwrap();
            // @ts-ignore
            dispatch(setCredentials({...res}));
            navigate(redirect);
        } catch (error: any) {
            toast.error("Employee Number or Last Name does not match");
        }
    }

    useEffect(() => {
        if (userInfo) {
            navigate((redirect))
        }
    }, [navigate, redirect, userInfo]);


    return (
        <>
            <main >

                <NavLink to={"/"} className={" py-2 px-2 flex items-center gap-2 hover:text-gray-700"}>
                    <img
                        src={assets.k_Solution_logo}
                        alt="K Solution"
                        className="w-[140px] sm:w-[140px] rounded-md shadow-2xl"
                    />
                </NavLink>

                <form className={'min-h-[80vh] flex items-center'}
                      onSubmit={onSubmitHandler}>
                    <div
                        className={'flex flex-col bg-gradient-to-r bg-blue-300 gap-3 m-auto items-start p-8 min-w-[360px] sm: min-w-120 border rounded-xl text-zinc-700 text-sm shadow-lg '}>
                        <p className={'text-3xl font-semibold mb-2'}
                           data-cy={"login-title"}
                        >Login</p>

                        <div className={'w-full'}>
                            <p className={"mb-2 text-lg font-semibold"}
                               data-cy={"email-headline"}
                            >Last Name</p>
                            <input className={'border border-zinc-700 rounded-lg w-full p-2 pt-1'}
                                   placeholder={"Enter Your Last Name"}
                                   type={'lastName'}
                                   value={lastName}
                                   required={true}
                                   data-cy={"error-email"}
                                   data-cx={"input-email"}
                                   onChange={(e) => setlastName(e.target.value)}/>
                        </div>

                        <div className={'w-full'}>
                            <p className={"mb-2 text-lg font-semibold"}
                               data-cy={"password-headline"}
                            >Employee Project ID</p>
                            <input className={'border border-zinc-700 rounded-lg w-full p-2 pt-1'}
                                   placeholder={"Enter Your Employee Project ID"}
                                   type={'password'}
                                   value={employeeNumber}
                                   required={true}
                                   data-cy={"error-employee-number"}
                                   data-cx={"input-employee-number"}
                                   onChange={(e) => setemployeeNumber(e.target.value)}/>
                        </div>

                        {/*<button*/}
                        {/*    // onClick={() => handleLogin()}*/}
                        {/*    type="submit"*/}
                        {/*    disabled={isLoading}*/}
                        {/*    data-cy={"submit"}*/}
                        {/*    className="flex w-full max-w-md mt-2 flex-1 items-center justify-center rounded-lg border border-transparent bg-indigo-600 px-8 py-2 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"*/}
                        {/*>*/}
                        {/*    Sign In*/}
                        {/*</button>*/}

                        <LoadingButton isLoading={isLoading }
                                       type={"submit"} loadingText={"Hold On Tight..."}>
                            Sign In
                        </LoadingButton>


                        <div className={"flex flex-col items-center"}>

                            <Link to={"/forgotPassword"}>
                                <p className={"text-blue-900 w-full items-center ml-20 underline-offset-0 text-md font-semibold cursor-pointer"}>Forgot
                                    password?</p>
                            </Link>
                        </div>
                    </div>
                </form>
            </main>
        </>
    )


}